module.exports = __webpack_public_path__ + "static/img/6.caf5936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/ovulation/6.png
// module id = vI9q
// module chunks = 1